import {createSelector} from 'reselect';
import get from 'lodash/get';

const timetrackingSelector = state => state.timetracking;

export const getReports = createSelector(
  [timetrackingSelector],
  timetracking => get(timetracking, 'timetracking', {})
);
